













import { defineComponent } from '@vue/composition-api'
import { TcButton } from '@telia/shared-ui-components'

import { AnslLink } from '@/components/common'

export default defineComponent({
  components: {
    AnslLink,
    TcButton
  },
  props: {
    href: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: null
    },
    variant: {
      type: String,
      default: 'stand-alone'
    },
    buttonText: {
      type: String,
      required: true
    }
  }
})
